// Centralized API and WebSocket configuration used by both CUSTOMER and AGENT flows

// Prefer environment overrides if present, but default to the unified base provided
export const API_BASE = process.env.REACT_APP_BACKEND_BASE_URL || "https://api-yeshtery.dev.meetusvr.com/v1";
export const WS_URL = process.env.REACT_APP_WS_URL || "https://api-yeshtery.dev.meetusvr.com/ws";

// Assign object to a variable before exporting
const config = { API_BASE, WS_URL };
export default config;
